import { Injectable } from '@angular/core';
import { CONSTANTS } from '../Constants/Constants';

@Injectable({
  providedIn: 'root'
})
export class NameValidationService {
  // Regex pattern for validating item names (used for estimate/project names)
  private readonly itemNameRegexPattern = /^[-]?[A-Za-zà-źâ-ŷÁ-ŹàÀÉÈÛç0-9%,&/.()'’ ]+(?:-[A-Za-zà-źâ-ŷÁ-ŹàÀÉÈÛç0-9%,&/.()'’ ]+)*[-]?$/;

  constructor() { }

  /**
   * Validates and cleans text input for names (estimate/project names and descriptions).
   * 
   * @param value The input value to validate
   * @param previousValue The previously valid value to fall back to
   * @param fieldType Type of field being validated ('estimateName' or 'description')
   * @returns The validated/cleaned value or the previous value if invalid
   */
  validateAndCleanName(
    value: string,
    previousValue: string,
    fieldType: 'estimateName' | 'description' = 'estimateName'
  ): string {
    // Find the index of the first invalid character
    const invalidCharacterIndex = value.search(/[^-A-Za-zà-źâ-ŷÁ-ŹàÀÉÈÛç0-9%,&/.()'’ ]/);
    const hasInvalidCharacter = invalidCharacterIndex !== -1;
    
    // Clean the value by removing everything from the first invalid character and trim
    const cleanedValue = (invalidCharacterIndex === -1
      ? value
      : value.substring(0, invalidCharacterIndex)).trim();
    
    // Validate the cleaned value against the pattern
    const isValid = cleanedValue.length > CONSTANTS.ZERO && this.itemNameRegexPattern.test(cleanedValue);
    
    // For descriptions, allow empty strings if no invalid characters were found
    // For names (estimateName), require non-empty and valid pattern
    const nextValue = isValid || (fieldType === 'description' && !hasInvalidCharacter && cleanedValue.length === CONSTANTS.ZERO)
      ? cleanedValue
      : previousValue;

    return nextValue;
  }
}
